import * as React from 'react';
import { useState } from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { DetailInfographic } from '../DetailInfographic';
import { AdditionalRating } from '../../../../../models/hotel-reviews';
import S from '../../../../../stores';
import AggregateRating from 'sletat-ui-components2/dist/components/AggregateRating';

export interface ReviewHeaderProps {
    title?: string;
    rating?: number;
    additionalRating: AdditionalRating;
}

interface StyledReviewHeaderProps extends JSSClassesProps<ComponentJSSClasses>, ReviewHeaderProps {}

export function ReviewHeader(props: StyledReviewHeaderProps) {
    const { classes, title = '', rating = 0, additionalRating } = props;
    const [showDetail, setShowDetail] = useState<boolean>(false);

    const handleShowDetail = () => setShowDetail((st) => !st);

    return (
        <div className={classes.wrapper}>
            <div className={classes.container}>
                <AggregateRating rating={rating} size="large" />
                <div className={classes.titleWrapper}>
                    <h3 className={classes.title}>
                        {title || `Отзыв об отеле ${S.hotelDetails.hotelName}`}
                    </h3>
                    {additionalRating && Object.values(additionalRating).length ? (
                        <button
                            className={classes.showDetailButton}
                            onClick={handleShowDetail}
                            type="button"
                        >
                            {showDetail ? 'Скрыть детали' : 'Детальная оценка'}
                        </button>
                    ) : null}
                </div>
            </div>
            {showDetail ? (
                <div className={classes.detailWrapper}>
                    <DetailInfographic additionalRating={additionalRating} />
                </div>
            ) : null}
        </div>
    );
}
